import {Component} from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {AccountProvider} from "../../providers/account/account";
import {FisoMathProvider} from "../../providers/fiso-math/fiso-math";

/**
 * Generated class for the VideoShopPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-video-shop',
    templateUrl: 'video-shop.html',
})
export class VideoShopPage {
    isSuccess = false;
    messageSuccess = ``;
    orderCode = null;

    paymentMethods = false;
    item: any = {};

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public accountProfile: AccountProvider,
                public fisoMathProvider: FisoMathProvider) {
        this.item = this.navParams.get('item');
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad VideoShopPage');
    }

    confirmOrder() {
        const confirm = this.alertCtrl.create({
            title: 'Xác nhận mua hàng',
            message: 'Bạn có chắc rằng là muốn mua và tiến hành thanh toán Video này?',
            buttons: [
                {
                    text: 'Đóng'
                },
                {
                    text: 'Xác nhận',
                    handler: () => {
                        this.paymentMethods = true;
                    }
                }
            ]
        });
        confirm.present();
    }

    parseCourseWay(course_way) {
        course_way = course_way.replace(/\[heading\]/g, '<h4>');
        course_way = course_way.replace(/\[end:heading\]/g, '</h4>');

        course_way = course_way.replace(/\[row\]/g, `<p> <img src="assets/imgs/icons/play-button.png" />`);
        course_way = course_way.replace(/\[end:row\]/g, '</p>');


        // course_way = this.nl2br(course_way);

        return course_way;
    }

    nl2br(value: string, args: string[] = []): any {
        if (!value) return value;
        let breakTag = '<br>';
        return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
    }

    order(paymentMethod) {
        let loader = this.loadingCtrl.create({
            content: "Vui lòng chờ giây lát ..."
        });
        loader.present();

        this.accountProfile.loadProfile().subscribe((resp: any) => {
            let user = resp.data;
            let paymentMessage = resp.data.options[`message_payment_${paymentMethod}`].option_value;


            this.fisoMathProvider.save_posts({
                code: this.item.id,
                post_type: 'course_ordering',
                title: `${user['title']} đã tiến hành mua khóa học ${this.item.title}`,
                parent_id: user.id,
                is_disabled: 1,
                metas: {
                    payment_method: paymentMethod,
                    order_message: paymentMessage
                }
            }).subscribe((resp: any) => {
                const post = resp.data;

                this.orderCode = post.id;
                paymentMessage = paymentMessage.replace('[ma_don_hang]', post.id);

                this.isSuccess = true;
                this.messageSuccess = paymentMessage;

                loader.dismiss();
            }, err => {
                loader.dismiss();
            });
        }, err => {
            loader.dismiss();
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/video-shop/video-shop.ts